import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./Entry.module.sass";
import inputStyle from "../../../components/TextInput/TextInput.module.sass";
import Icon from "../../../components/Icon";
import { AuthSignUp } from "../../../auth";
import { useLocation } from "react-router";
import Loader from "../../../components/Loader";
import { useUser } from "../../../context";
import auth from "../../../i11/auth";

const Entry = ({ onConfirm = () => {}, setVerifyData = () => {} }) => {
	const { locale } = useUser();
	const [passwordShown, setPasswordType] = useState("password");
	const [loading, setLoading] = useState(false);
	const [signWithQuery, setSignWithQuery] = useState(false);
	const ref = useRef();
	const ref1 = useRef();
	const search = useLocation().search;

	const chosen = new URLSearchParams(search).get("chosen");
	const uniqueCode = new URLSearchParams(search).get("uniqueCode");
	const org = new URLSearchParams(search).get("org");
	let mail = new URLSearchParams(search).get("mail");
	if (mail.split(" ").length == 2) {
		mail = mail.split(" ")[0] + "+" + mail.split(" ")[1];
	}
	const name = new URLSearchParams(search).get("name");

	const togglePassword = () => {
		if (passwordShown === "password") {
			setPasswordType("text");
			return;
		}
		setPasswordType("password");
	};

	useEffect(() => {
		if (chosen && org && mail && name) setSignWithQuery(true);
	}, []);

	const signUp_ = (e) => {
		e.preventDefault();
		const username = e.target.elements.username.value;
		const email = e.target.elements.email.value;
		const password = e.target.elements.password.value;
		const passwordRepeat = e.target.elements.passwordRepeat.value;
		if (
			/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&_])[A-Za-z\d@#$!_%*?&]{8,}/gm.exec(
				password
			) === null
		) {
			ref.current.setCustomValidity(auth[locale].pass_val);
			return;
		}
		if (!passwordRepeat.match(password)) {
			ref1.current.setCustomValidity(auth[locale].pass_val_diff);
			return;
		}
		AuthSignUp(
			{
				username,
				email,
				password,
				uniqueCode,
				passwordRepeat,
				chosen: chosen,
				org: org,
			},
			setVerifyData,
			onConfirm,
			setLoading
		);
	};

	return (
		<div className={styles.entry}>
			<div className={styles.body}>
				<form autoComplete="off" className="signUpForm" onSubmit={signUp_}>
					{signWithQuery && (
						<>
							<div
								rules={[
									{
										required: true,
										message: auth[locale].provide_brand_name,
									},
								]}
							>
								<div
									className={cn(
										inputStyle.field,
										{ [inputStyle.fieldIcon]: "profile" },
										styles.field
									)}
								>
									<div className={inputStyle.wrap}>
										<input
											initialvalue={name}
											name="brandname"
											autoComplete="off"
											required
											type={"text"}
											defaultValue={name}
											readOnly={true}
											disabled={true}
											placeholder={"Brand Name"}
											className={cn(inputStyle.input)}
										/>
										<div className={inputStyle.icon}>
											<Icon svgImage={"brandSvg"} />{" "}
										</div>
									</div>
								</div>
							</div>
						</>
					)}
					<div>
						<div
							className={cn(
								inputStyle.field,
								{ [inputStyle.fieldIcon]: "profile" },
								styles.field
							)}
						>
							<div className={inputStyle.wrap}>
								<input
									name="username"
									onInput={(e) => e.target.setCustomValidity("")}
									onInvalid={(e) =>
										e.target.setCustomValidity("Please input your Username!")
									}
									autoComplete="new-password"
									required
									type="name"
									placeholder={auth[locale].user_name}
									className={inputStyle.input}
								/>
								<div className={inputStyle.icon}>
									<Icon name={"profile"} size="24" viewBox={"0 0 448 512"} />{" "}
								</div>
							</div>
						</div>
					</div>
					<div>
						<div
							className={cn(
								inputStyle.field,
								{ [inputStyle.fieldIcon]: "email" },
								styles.field
							)}
						>
							<div className={inputStyle.wrap}>
								<input
									required
									initialvalue={mail ? mail : ""}
									name="email"
									autoComplete="off"
									type="email"
									readOnly={signWithQuery}
									defaultValue={mail ? mail : ""}
									disabled={signWithQuery}
									placeholder={"Email"}
									className={cn(inputStyle.input)}
								/>
								<div className={inputStyle.icon}>
									<Icon name={"mail"} size="24" />{" "}
								</div>
							</div>
						</div>
					</div>
					<div>
						<div
							className={cn(
								inputStyle.field,
								{ [inputStyle.fieldIcon]: "password" },
								styles.field
							)}
						>
							<div className={inputStyle.wrap}>
								<input
									minLength={8}
									ref={ref}
									name="password"
									onInput={(e) => e.target.setCustomValidity("")}
									onInvalid={(e) => {
										if (e.target.value === "")
											e.target.setCustomValidity("Please enter a password");
										else if (e.target.value.length < 8)
											e.target.setCustomValidity(
												"Password must have a minimum length of 8"
											);
									}}
									required
									autoComplete="off"
									type={passwordShown === "password" ? "password" : "text"}
									placeholder={auth[locale].password}
									className={cn(inputStyle.input)}
								/>
								<div className={inputStyle.icon}>
									<Icon name={"lock"} size="24" />{" "}
								</div>
								<div className={inputStyle.passwordShow}>
									<button type="button" tabIndex="-1" onClick={togglePassword}>
										{passwordShown === "password" ? (
											<Icon svgImage={"hideEye"} />
										) : (
											<Icon svgImage={"eye"} />
										)}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div
							className={cn(
								inputStyle.field,
								{ [inputStyle.fieldIcon]: "password-repeat" },
								styles.field
							)}
						>
							<div className={inputStyle.wrap}>
								<input
									ref={ref1}
									onInput={(e) => e.target.setCustomValidity("")}
									onInvalid={(e) =>
										e.target.setCustomValidity("Please confirm your password!")
									}
									required
									name="passwordRepeat"
									autoComplete="off"
									type="password"
									placeholder={auth[locale].confirm_pass}
									className={cn(inputStyle.input)}
								/>
								<div className={inputStyle.icon}>
									<Icon name={"lock"} size="24" />{" "}
								</div>
							</div>
						</div>
					</div>
					<div>
						<button
							className={cn(
								`button ${loading ? "disabled" : ""}`,
								styles.button
							)}
							type="submit"
						>
							{loading ? <Loader white /> : <span>{auth[locale].cont}</span>}
						</button>
					</div>
				</form>
				<div className={styles.note}>{auth[locale].disclaimer}</div>
			</div>
		</div>
	);
};

export default Entry;
